import { Grid } from 'antd'
import useTitle from 'app/lib/hooks/useTitle'
import { PageProps } from 'app/pages/typing'
import * as React from 'react'

import DesktopOverview from '../Container/DesktopOverview'
import MobileOverview from '../Container/MobileOverview'

const Overview: React.FC<PageProps> = (props) => {
  const { md } = Grid.useBreakpoint()
  useTitle(props)

  return (
    <Choose>
      <When condition={md}>
        <DesktopOverview {...props} />
      </When>
      <Otherwise>
        <MobileOverview {...props} />
      </Otherwise>
    </Choose>
  )
}

export default Overview
